import {formatNumber, formatNumberShort} from '../../../helpers/functions/functions'
import NoDataLineDark from '../../../assets/line-dark.svg'
import NoDataLineWhite from '../../../assets/line-white.svg'
import NoDataPieDark from '../../../assets/pie-dark.svg'
import NoDataPieWhite from '../../../assets/pie-white.svg'
import NoDataDoughnutDark from '../../../assets/doughnut-dark.svg'
import NoDataDoughnutWhite from '../../../assets/doughnut-white.svg'


export const GraphicNoDataImg ={
  NoDataDoughnutDark,
  NoDataLineDark,
  NoDataLineWhite,
  NoDataPieDark,
  NoDataPieWhite,
  NoDataDoughnutWhite
}

export const LinearGraphicColor = [
  '#FC377D',
  '#F1C775',
  '#5ABCA5',
  '#7488CC',
  '#8038FA',
  '#006F95',
  '#DE6149',
  '#3752F2',
  '#F14672',
  '#DD2AD1',
  '#F2E160',
  '#00C8A7',
  '#86B865',
  '#504175',
  '#FF5E5E',
  '#FF9F43',
  '#FFD56A',
  '#A3E635',
  '#4CCD99',
  '#00B4D8',
  '#5E60CE',
  '#FF6B6B',
  '#FFA502',
  '#FFD166',
  '#06D6A0',
  '#118AB2',
  '#073B4C',
  '#EF476F',
  '#FFC43D',
  '#1B9AAA',
  '#6A4C93',
  '#F72585',
  '#7209B7',
  '#3A0CA3',
  '#4361EE',
  '#4CC9F0',
  '#F8961E',
  '#F94144',
  '#F3722C',
  '#F9C74F',
  '#90BE6D',
  '#43AA8B',
  '#577590',
  '#277DA1',
  '#E63946',
  '#F1C453',
  '#A8DADC',
  '#457B9D',
  '#1D3557',
  '#FF70A6',
  '#FF9770',
  '#FFD670',
  '#E9FF70',
  '#70D6FF',
  '#FF70A6',
  '#B5179E',
  '#560BAD',
  '#480CA8',
  '#3F37C9',
  '#4895EF',
  '#4CC9F0',
  '#F72585',
  '#B5179E',
  '#7209B7',
  '#FF4D6D',
  '#FF8E4F',  
  '#FFD23F',  
  '#A7F3D0',
  '#60A5FA',  
  '#C084FC',  
  '#F472B6',  
  '#4ADE80',  
  '#38BDF8',  
  '#818CF8',
  '#FB7185',  
  '#F59E0B',
  '#10B981',  
  '#0EA5E9',  
  '#8B5CF6',  
  '#EC4899',
  '#F97316',  
  '#22D3EE',  
  '#A78BFA',  
  '#F43F5E',
  '#FF3E6D',
  '#FF7D47',
  '#FFCB45',
  '#8CFF32',
  '#00E3B2',
  '#36D6E7',
  '#7B6BFF',
  '#D83BFF',
  '#FF4DCC',
  '#FF5E7E',
  '#FF8A4A',
  '#FFD700',
  '#6AFF5C',
  '#00FFC4',
  '#4D8AFF',
  '#B84DFF',
  '#FF47A3',
  '#FF6B35',
  '#C3FF00',
  '#FF2D75' 
]
export const LinearGraphicColorDark = [
  '#FC377D',
  '#F1C775',
  '#5ABCA5',
  '#7488CC',
  '#8038FA',
  '#006F95',
  '#DE6149',
  '#3752F2',
  '#F14672',
  '#DD2AD1',
  '#F2E160',
  '#00C8A7',
  '#86B865',
  '#504175',
  '#FF5E5E',
  '#FF9F43',
  '#FFD56A',
  '#A3E635',
  '#4CCD99',
  '#00B4D8',
  '#5E60CE',
  '#FF6B6B',
  '#FFA502',
  '#FFD166',
  '#06D6A0',
  '#118AB2',
  '#073B4C',
  '#EF476F',
  '#FFC43D',
  '#1B9AAA',
  '#6A4C93',
  '#F72585',
  '#7209B7',
  '#3A0CA3',
  '#4361EE',
  '#4CC9F0',
  '#F8961E',
  '#F94144',
  '#F3722C',
  '#F9C74F',
  '#90BE6D',
  '#43AA8B',
  '#577590',
  '#277DA1',
  '#E63946',
  '#F1C453',
  '#A8DADC',
  '#457B9D',
  '#1D3557',
  '#FF70A6',
  '#FF9770',
  '#FFD670',
  '#E9FF70',
  '#70D6FF',
  '#FF70A6',
  '#B5179E',
  '#560BAD',
  '#480CA8',
  '#3F37C9',
  '#4895EF',
  '#4CC9F0',
  '#F72585',
  '#B5179E',
  '#7209B7',
  '#FF4D6D',
  '#FF8E4F',  
  '#FFD23F',  
  '#A7F3D0',
  '#60A5FA',  
  '#C084FC',  
  '#F472B6',  
  '#4ADE80',  
  '#38BDF8',  
  '#818CF8',
  '#FB7185',  
  '#F59E0B',
  '#10B981',  
  '#0EA5E9',  
  '#8B5CF6',  
  '#EC4899',
  '#F97316',  
  '#22D3EE',  
  '#A78BFA',  
  '#F43F5E',
  '#FF3E6D',
  '#FF7D47',
  '#FFCB45',
  '#8CFF32',
  '#00E3B2',
  '#36D6E7',
  '#7B6BFF',
  '#D83BFF',
  '#FF4DCC',
  '#FF5E7E',
  '#FF8A4A',
  '#FFD700',
  '#6AFF5C',
  '#00FFC4',
  '#4D8AFF',
  '#B84DFF',
  '#FF47A3',
  '#FF6B35',
  '#C3FF00',
  '#FF2D75' 
]

export const PieGraphicColor = [
  'rgba(163, 163, 163, 0.25)','rgba(163, 163, 163, 0.35)','rgba(223, 223, 223, 0.5)'
  
  
]
export const PieGraphicColorDark =  ['rgba(163, 163, 163, 0.25)','rgba(163, 163, 163, 0.35)','rgba(223, 223, 223, 0.5)' ]

export const DoughnutGraphicColor = ['#1BC3DD','#077586']

export const DoughnutGraphicColorDark =  ['#1cc3dd','#077586']


export const GetPieGraphicOptions = (darkMode, dashboardData) => {
  return ({
    responsive:true,
    aspectRatio: 1.4,
    radius:'70%',
    plugins:{
        legend:{
            display:false
        },
        tooltip:{
            enabled:false
        },
        datalabels:{
            labels: {
                index: {
                  align: 'end',
                  anchor: 'end',
                  color: darkMode ? "white": 'black',
                  font: {size: 15},
                  formatter: function(value, ctx) {
                    return  ctx.chart.data.labels[ctx.dataIndex];
                  },
                  offset: 8,
                
                },
                name: {
                  align: 'top',
                  color:  darkMode ? "white":"#000000B2",
                  font: {size:18 , weight:"bold"},
                  formatter: function(value, ctx) {
                    const total = dashboardData.totalSuccessful + dashboardData.totalFailed
                    return `${((value * 100) / total).toFixed(1)}%`
                  },
                  padding:{
                    
                    bottom:-18
                  }
                },
                value: {
                  align: 'bottom',
                  font: {size: 12},
                  color: darkMode ? "white": 'black',    
                  formatter: function(value, ctx) {
                    return formatNumber(value)
                  },
                  padding:0
                }
              }
           
          },  
    },
  })
}

export const GetLineGraphicOptions = (darkMode, dateRange, datasets) => {
  return ({
    responsive: true,
    scales:{
        y:{
            display:true,
            grid:{
                display:true,
                color: 'rgba(224, 224, 224, 0.5)',
                borderDash: [5, 5]
                
            },
        },
        x:{
            
            grid:{
                display:true,
                color: 'rgba(224, 224, 224, 0.5)',
                borderDash: [5, 5]
                
            },
            ticks:{
                maxTicksLimit:16,
                autoSkip:true,
                
            },
            
           
            
        }
    },
    elements:{
        line:{
            tension:0.5,
            borderWidth:3
        },
        point:{
            radius:2.5,
            hoverRadius:12,
            hoverBackgroundColor: darkMode ? "black": 'white',
            hoverBorderWidth:5
        }
    },
    plugins: {
      legend: {
        position: 'top',
        display:false
      },
      title: {
        display: false,
      },
      datalabels:{
        labels:{
            title:null
        }
    },
      tooltip:{
        backgroundColor: !darkMode ? "white" : "#4E4E4E",
        bodyColor: !darkMode ? "#000" : "white",
        borderColor: !darkMode ? "#1BC3DD" : "#1BC3DD",
        borderWidth: 1,
        titleColor: !darkMode ? "#000": "white",
        titleAlign:"center",
        bodyAlign:'center',
        displayColors:false,
        padding:10,
        position: 'nearest',
        xAlign: 'right',
        yAlign: 'center',
        callbacks:{
            title: (context) => {

                return ` ${context[0].dataset.labels}`

            },
            afterTitle: (context) => {
              return` ${dateRange.startDate.format('MMM')} ${context[0].label}`
            }

        }


      }
    },
  })
}

export const GetDoughnutGraphicOptions = (darkMode, dashboardData, width) => {
 
  return ({
    responsive:true,
    aspectRatio: 1,
    radius: width > 1800 ? "80%" : "70%",
    cutout: "70%",
    plugins:{
        legend:{
            position:"bottom",
            labels:{
                boxWidth:11,
                color: darkMode ? "white" : 'black'
            },
        },
        fillStyle: darkMode ? 'white': 'black',
        
        tooltip:{
            displayColors:false,
            backgroundColor: !darkMode ? "white" : "#4E4E4E",
            bodyColor: !darkMode ? "#000" : "white",
            borderColor: !darkMode ? "#1BC3DD" : "#1BC3DD",
            borderWidth: 1,
            titleColor: !darkMode ? "#000": "white",
        },
        datalabels:{
            labels: {
                index: {
                  align: 'end',
                  anchor: 'end',
                  color:  darkMode ? "white": 'black',
                  font: {size: 16, weight:'bold'},
                  
                  formatter: function(value, ctx) {
                    const total = dashboardData.totalSuccessful + dashboardData.totalFailed
                    return `${((value * 100) / total).toFixed(2)}%`
                   
                  },
                  offset: 8,
                
                },
            
              }
           
          },
        
        
    },
    
})
}
//# COLORES Y ETIQUETAS DEL DASHBOARD ANUAL

export const CARRIER_COLORS = {
  MOVISTAR: '#009EF7',
  DIGITEL: '#E0003F',
  MOVILNET: '#F05A5D'
}

export const KPI_MONTH_BORDER_COLOR = 'rgba(168, 56, 215, 0.5)'

export const ANNUAL_SUCCESS_COLOR = '#1BC3DD'

export const ANNUAL_FAILED_COLOR = '#077586'

export const MONTH_SHORT_LABELS = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic']
